"use strict";
/* eslint @typescript-eslint/ban-ts-comment: 0 */
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RatingSlider = void 0;
/**
 * the two ts-ignore's below will be fixed in v9 of react-spring which is not
 * released yet.
 *
 * https://github.com/pmndrs/react-spring/issues/723
 */
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var rc_slider_1 = __importDefault(require("rc-slider"));
var react_spring_1 = require("react-spring");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var faStar_1 = require("@fortawesome/free-solid-svg-icons/faStar");
var RatingSlider = function (props) {
    var className = props.className, disabled = props.disabled, userRating = props.userRating, submitRating = props.submitRating;
    var animateMarks = function (markIndex) { return function (index) {
        return index === markIndex ? { y: -6, scale: 1.6 } : { y: -2, scale: 1 };
    }; };
    var _a = (0, react_spring_1.useSprings)(10, animateMarks(userRating ? -1 : userRating - 1)), springs = _a[0], setSprings = _a[1];
    var _b = (0, react_1.useState)(userRating === null ? 0 : userRating), activeValue = _b[0], setActiveValue = _b[1];
    var _c = (0, react_1.useState)(null), hasSetRating = _c[0], setHasSetRating = _c[1];
    (0, react_1.useEffect)(function () {
        if (userRating !== null && userRating !== 0 && hasSetRating === null) {
            setActiveValue(userRating);
            // @ts-ignore ¯\_(ツ)_/¯
            setSprings(animateMarks(userRating - 1));
        }
    }, [setSprings, setActiveValue, userRating, hasSetRating]);
    var handleOnAfterChange = function (value) {
        setHasSetRating(true);
        submitRating(value);
    };
    var handleOnChange = function (value) {
        var index = value - 1;
        setActiveValue(value);
        // @ts-ignore ¯\_(ツ)_/¯
        setSprings(animateMarks(index));
    };
    var ratingHandle = function (handleProps) { return (react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faStar_1.faStar, style: { left: "".concat(handleProps.offset, "%") }, className: "star" })); };
    var renderMark = function () { return (react_1.default.createElement("div", { className: "mark-wrap" }, springs.map(function (_a, i) {
        var y = _a.y, scale = _a.scale;
        return (react_1.default.createElement(react_spring_1.animated.span, { className: "mark-text ".concat(activeValue === i + 1 ? 'active' : ''), key: i, style: {
                left: "".concat((i + 1) * 10, "%"),
                transform: (0, react_spring_1.interpolate)([y, scale], function (y, scale) { return "translate3d(-50%,".concat(y, "px,0) scale(").concat(scale, ")"); }),
            } }, i + 1));
    }))); };
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement(rc_slider_1.default, { min: 0, max: 10, defaultValue: activeValue, value: activeValue, handle: ratingHandle, marks: {
                0: '',
                1: 1,
                2: 2,
                3: 3,
                4: 4,
                5: 5,
                6: 6,
                7: 7,
                8: 8,
                9: 9,
                10: 10,
            }, trackStyle: { backgroundColor: '#f9d083' }, onChange: function (value) {
                handleOnChange(value);
            }, onAfterChange: function (value) {
                handleOnAfterChange(value);
            }, disabled: disabled }),
        renderMark()));
};
exports.RatingSlider = RatingSlider;
var StyledRatingSlider = (0, styled_components_1.default)(exports.RatingSlider)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  min-width: 200px;\n\n  .rc-slider {\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    z-index: 2;\n  }\n\n  .rc-slider-disabled {\n    background-color: transparent;\n  }\n\n  .rc-slider-dot-active,\n  .rc-slider-dot {\n    background-color: ", ";\n    border: none;\n    border-radius: 0px;\n    width: 1px;\n    height: 8px;\n    margin: 0px;\n  }\n\n  .rc-slider-mark {\n    top: -22px;\n    opacity: 0;\n    z-index: 1;\n  }\n\n  .mark-wrap {\n    top: -22px;\n    height: 30px;\n    position: absolute;\n    left: 0;\n    width: 100%;\n    font-size: 1rem;\n    z-index: 0;\n  }\n\n  .mark-text {\n    position: absolute;\n    cursor: pointer;\n  }\n\n  & .star {\n    position: absolute;\n    color: #ffc307;\n    top: -2px;\n    margin-left: -5%;\n    z-index: 3;\n    font-size: 1.43rem;\n    max-width: 25px;\n  }\n\n  & .trash {\n    left: 0px;\n    z-index: 2;\n    width: 25px;\n    position: absolute;\n    margin: 0px 0px 0px -12px;\n    color: ", ";\n    font-size: 1.15rem;\n    pointer-events: none;\n    opacity: 0 !important; // disabling show trash for now\n  }\n"], ["\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  min-width: 200px;\n\n  .rc-slider {\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    z-index: 2;\n  }\n\n  .rc-slider-disabled {\n    background-color: transparent;\n  }\n\n  .rc-slider-dot-active,\n  .rc-slider-dot {\n    background-color: ", ";\n    border: none;\n    border-radius: 0px;\n    width: 1px;\n    height: 8px;\n    margin: 0px;\n  }\n\n  .rc-slider-mark {\n    top: -22px;\n    opacity: 0;\n    z-index: 1;\n  }\n\n  .mark-wrap {\n    top: -22px;\n    height: 30px;\n    position: absolute;\n    left: 0;\n    width: 100%;\n    font-size: 1rem;\n    z-index: 0;\n  }\n\n  .mark-text {\n    position: absolute;\n    cursor: pointer;\n  }\n\n  & .star {\n    position: absolute;\n    color: #ffc307;\n    top: -2px;\n    margin-left: -5%;\n    z-index: 3;\n    font-size: 1.43rem;\n    max-width: 25px;\n  }\n\n  & .trash {\n    left: 0px;\n    z-index: 2;\n    width: 25px;\n    position: absolute;\n    margin: 0px 0px 0px -12px;\n    color: ", ";\n    font-size: 1.15rem;\n    pointer-events: none;\n    opacity: 0 !important; // disabling show trash for now\n  }\n"])), function (props) { return props.theme.primary1; }, function (props) { return props.theme.primary4; });
exports.default = StyledRatingSlider;
var templateObject_1;
